import { FormikProps } from 'formik';
import { TFunction } from 'i18next';
import PropTypes from 'prop-types';
import { RouteComponentProps } from 'react-router-dom';

import { Config } from '../config';

export interface IsReadyToRenderProp {
    isReadyToRender: boolean;
}

export interface ConfigProp {
    config: Config;
}

export interface RenderPropWithProps<T> {
    children(props: T): React.ReactNode;
}

export interface OptionalRenderPropWithProps<T> {
    children?(props: T): React.ReactNode;
}

export interface RenderProp {
    children(): React.ReactNode;
}

export interface TranslationFuncProp {
    t: TFunction;
}

export interface RoutePropsT<T extends { [K in keyof T]?: string }> {
    routeProps: RouteComponentProps<T>;
}

export interface RouteProps {
    routeProps: RouteComponentProps;
}

export interface GenericRouteProps<T extends { [K in keyof T]?: string }> {
    routeProps: RouteComponentProps<T>;
}

export interface MyFormikProps<T> {
    formikProps: FormikProps<T>;
}
export const LookupValueDTOShape = {
    label: PropTypes.string.isRequired,
};
